export const CST_CERTIFICATE_STYLE = {
    bySite: 0,
    byOrder: 1,
    byDN: 2,
    byTag: 3
};

/**
 * Repris de DATA.pas ligne 173
 */
export const CST_PRINTING_LIST_TYPE_XMLFile = {
    LISTE_CONTRAT: 1,
    LISTE_CHANTIER: 2,
    LISTE_CLIENT: 3,
    LISTE_FOURNISSEUR: 4,
    LISTE_ETIQSTOCK: 5,
    LISTE_BL: 6,
    LISTE_PRODUIT: 7,
    LISTE_FACTURE: 8,
    //LISTE_DEVIS: 9,
    //LISTE_ETIQASS: 10,
    LISTE_EMPLOYE: 11,
    LISTE_CHUTES: 12,
    LISTE_PLANS: 13,
    LISTE_COMMANDE: 14,
    //LISTE_STEELLIST: 15,
    //LISTE_ENTREE_STOCK: 16
};

/**
 * Utiliser pour acceder au donnée stocké dans le local ou le session storage
 *
 * Session storage  : données stockée le temps d'acces sur le site
 * Local storage    : données stockée sur le pc, peut reutiliser apres un redemarage
 */
export const CST_LOCALSTORAGE_VALUE = {
    /** */
    User: '8f9bfe9d1345237cb3b2b205864da075',
    /** */
    SelectedSiteCode: '7690d7944e5ce6b56aa05c48610f5e23',
    /** */
    UserParam: 'UserParam',
    /** Backup de la liste d'acier */
    WEB_ANALYSIS_BACKUP: 'CST_LOCALSTORAGE_ANALYSIS_BACKUP'
};

/**
 * Le status correspondant a armaor
 * @see ArmaRestOrderList
 */
export const SteelListStatus = {
    'stWaiting': 0,
    'stValidate': 1,
    'stDeny': 2,
    'stCancel': 3,
    'stSend': 4
};

/**
 * Identificateur pour l'interface CoteForme
 * A utiliser avec le champ Calc pour connaitre la visibility
 * @see CoteForme.Calc
 */
export const CALC_VISIBILITY_COTE = {
    ALWAS_VISIBLE: 0, // Correspond à la cote a saisire
    VISIBLE_TO_CALCULATE: 1,
    HIDDEN_TO_CALCULATE: 2
};

/**
 * Unités des dimensions de treillis
 * @see g_params
 */
export const MESH_UNIT = {
  MESH_UNIT_Cm: 0,
  MESH_UNIT_mm: 1,
  MESH_UNIT_m: 2
};
